var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { GREEN_500, YELLOW_600, RED_400, TRANSPARENT, WHITE } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getBackgroundDimensions = platform => {
  var dimensions = {
    web: {
      width: 96,
      height: 96,
      borderRadius: 48
    },
    mobile: {
      width: 72,
      height: 72,
      borderRadius: 36
    }
  };
  return dimensions[platform];
};
export var getBgColor = function getBgColor(type) {
  if (type === void 0) {
    type = 'success';
  }
  var colorMap = {
    success: GREEN_500,
    warning: YELLOW_600,
    danger: RED_400
  };
  return colorMap[type] || TRANSPARENT;
};
export var getStatusCardSvgGradientStyles = (props, platform) => {
  var height = props.height,
    width = props.width,
    borderRadius = props.borderRadius,
    type = props.type;
  var dimensions = getBackgroundDimensions(platform);
  return StyleSheet.create({
    container: Object.assign(Object.assign({}, props), {
      width: width !== null && width !== void 0 ? width : dimensions.width,
      height: height !== null && height !== void 0 ? height : dimensions.height,
      borderRadius: borderRadius !== null && borderRadius !== void 0 ? borderRadius : dimensions.borderRadius,
      justifyContent: 'center',
      alignItems: 'center'
    }),
    statusContainer: {
      backgroundColor: getBgColor(type)
    }
  });
};
export var getStatusCardSvgIconSize = (props, platform) => {
  var fontSize = props.fontSize;
  var dimensions = {
    web: 48,
    mobile: 36
  };
  return fontSize || dimensions[platform];
};
export var getStatusCardSvgIconProps = props => {
  var _props$color = props.color,
    color = _props$color === void 0 ? WHITE : _props$color,
    restProps = __rest(props, ["color"]);
  return Object.assign(Object.assign({}, restProps), {
    color
  });
};